import { render } from "./Ribbon.vue?vue&type=template&id=6ddd2dfe"
const script = {}

import exportComponent from "/app/tmp/blackhall/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__